import { FallbackRender } from "@sentry/react/types/errorboundary";
import styled from "styled-components";

const ErrorFallback: FallbackRender = ({ error, resetError }) => (
    <Container>
        <ErrorBox>
            <Title>Error Occurred</Title>
            <ErrorMessage>
                <div>Note: The error has been reported.</div>
                <div>{error.toString()}</div>
            </ErrorMessage>
            <StyledButton
                onClick={() => {
                    resetError();
                }}
            >
                CONFIRM
            </StyledButton>
        </ErrorBox>
    </Container>
);

const Container = styled.div`
    height: 100vh;
    width: 100vw;

    background: #e0eafc; /* fallback for old browsers */
    background: -webkit-linear-gradient(
        to right,
        #cfdef3,
        #e0eafc
    ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
        to right,
        #cfdef3,
        #e0eafc
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    display: grid;
    place-items: center;

    overflow: hidden;
`;

const ErrorBox = styled.div`
    min-height: 20rem;
    width: 26rem;
    border-radius: 0.2rem;

    padding: 2rem;
    background-color: white;
    box-shadow: 1px 0px 10px 1px rgba(214, 214, 214, 0.25);

    display: flex;
    flex-flow: column;
    align-items: center;
`;

const Title = styled.h2`
    color: ${(props) => props.theme.colors.danger[400]};
    margin-bottom: 1.5rem;
`;

const ErrorMessage = styled.p`
    font-size: 1rem;
    margin-bottom: 1.5rem;
`;

const StyledButton = styled.button`
    width: 14rem;
    height: 2.6rem;
    background: ${(props) => props.theme.colors.primary[400]};
    border-radius: 0.2rem;
    box-shadow: 0px 8px 15px rgba(57, 120, 198, 0.15);
    color: ${(props) => props.theme.colors.neutral[100]};
    font-weight: ${(props) => props.theme.fontWeight.bold};
    margin-top: 1rem;
    transition: all 0.08s linear;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    &:hover {
        cursor: pointer;
        transform: scale(1.02);
    }

    & > * {
        &:nth-child(2) {
            stroke-width: 1.1rem;
            transform: scale(1.25);
        }
    }
`;

export default ErrorFallback;
